import {pageInfo, initPage} from './../api';
import {selectCarrier} from '../../../../api'
import { Message } from 'element-ui';
const order = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    carrierObj:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    CARRIER_INFO_DATA(state,data){
      state.carrierInfoObj = data.obj || [];
    },
    SELECT_CARRIER(state, resp){
      state.carrierObj = resp.obj || [];
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //物流商
    async ListCarrierSelect({ commit }, obj) {
      let resp = await selectCarrier(obj);
      commit('SELECT_CARRIER', resp);
    },
  }
}
export default order



// WEBPACK FOOTER //
// ./src/page/toBOrder/order/store/order.store.js